

<template>
  <div id="trikotwenderbutton" class="ele-hidden">
    <label class="left">Aussenseite</label>
    <label class="switch">
      <input id="trikotwender" type="checkbox" @change="$emit('changeside')">
      <span class="slider"></span>
    </label>
    <label class="right">Innenseite</label>
  </div>
</template>

<script lang="ts" setup>

</script>

<style scoped lang="scss">
#trikotwenderbutton {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 10px;

  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 10px;

  }

  input:checked + .slider {
    background-color: #2196F3;

  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;

  }

  input:checked + .slider:before {
    transform: translateX(26px);

  }
}
</style>


